import { Common, color } from '@stockbit/ui';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useState } from 'react';
import PasswordField from '../ChangePassword/PasswordField';
import { PasswordCancelButton, PasswordSubmitButton } from '../styled';

const { Flex, Text } = Common;

interface VerifyPasswordProps {
  isLoading: boolean;
  onSubmit: (password: string) => void;
  cancelLink: string;
  onClickCancel?: () => void;
  defaultPassword?: string;
}

function VerifyPassword({
  isLoading,
  onSubmit,
  cancelLink,
  onClickCancel = () => {},
}: VerifyPasswordProps) {
  const router = useRouter();
  const [password, setPassword] = useState<string>('');

  const handleSubmit = (e) => {
    e?.preventDefault();
    const pw = password;
    setPassword('');
    onSubmit(pw);
  };

  const handleCancel = () => {
    setPassword('');
    onClickCancel();
  };

  return (
    <form onSubmit={handleSubmit}>
      <Flex p="0 20px 20px 20px" width="100%" direction="column" margin="auto">
        <Flex direction="column" width="300px" mb="10px">
          <Text mb="20px">Masukkan Password Stockbit Kamu</Text>
          <PasswordField
            value={password}
            onChange={setPassword}
            isError={false}
          />
          <Text
            family="bold"
            color={color.primary}
            mt="20px"
            onClick={() => router.push('/forgot-password')}
            style={{ cursor: 'pointer' }}
            data-cy="verify-password-forget-password-link"
          >
            Lupa password?
          </Text>
        </Flex>
        <Flex mt="10px" ml="-15px">
          <Link href={cancelLink}>
            <PasswordCancelButton
              disabled={false}
              onClick={handleCancel}
              data-cy="verify-password-cancel-button"
            >
              Cancel
            </PasswordCancelButton>
          </Link>
          <PasswordSubmitButton
            htmlType="submit"
            disabled={!password}
            type="primary"
            loading={isLoading}
            onClick={handleSubmit}
            data-cy="verify-password-submit-button"
          >
            Submit
          </PasswordSubmitButton>
        </Flex>
      </Flex>
    </form>
  );
}

export default VerifyPassword;
